import React, { useState, useEffect } from 'react'
import { Steps, Space} from 'antd'
import { useFKspListQuery, useFKspjdListQuery } from '../../store/DianShangYeWuApi';
function CostNodeEdit(props) {
    const [items, setItems] = useState([])
    const {data, isSuccess} = useFKspListQuery({ddzc_sp_ddzc_id:props.ddzc_id},{skip:!props.ddzc_id})
    const {data:spjdData, isSuccess:spjdIsSuccess} = useFKspjdListQuery({ddzc_spjd_qy_id:props.qy_id,ddzc_spjd_user_id:props.user_id},{skip:!props.user_id});
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            const sortedData = [...data.Result].sort((a, b) => {
                return a.ddzc_sp_xuhao - b.ddzc_sp_xuhao;
            })
            const arr = sortedData.map((item) => ({
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>{item.ddzc_sp_jd_name}</span>       ,
                content:<Space orientation='vertical' size={1}>
                                <span>
                                {(item.ddzc_sp_state==='3' && item.ddzc_sp_jd_name==='抄送') && <span style={{color:"#000"}}>未读：</span>}
                                {(item.ddzc_sp_state==='3' && item.ddzc_sp_jd_name==='审批') && <span style={{color:"green"}}>已同意{item.ddzc_sp_content? '：'+item.ddzc_sp_content :''}</span>}
                                {(item.ddzc_sp_state==='4' && item.ddzc_sp_jd_name==='审批') && <span style={{color:"red",fontWeight:"bold"}}>已驳回{item.ddzc_sp_content? '：'+item.ddzc_sp_content :''}</span>}
                            </span>
                            <span style={(item.ddzc_sp_state==='3' || item.ddzc_sp_state==='4' || item.ddzc_sp_state==='5') ? {color:'#000'} : {}}>{item.ddzc_sp_yh_name} {item.ddzc_sp_state_time} </span>
                        </Space>,
            }))
            setItems([{
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                content:<span style={{fontSize:"12px"}}>{props.ddzc_uname} {props.ddzc_ctime}</span>,
            },
            {
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                content:<span style={{fontSize:"12px"}}>{props.ddzc_uname} {props.ddzc_state_time}</span>,
            },...arr]);
        }else{
            if(spjdIsSuccess && spjdData.Status === 'success'){
                const sortedData = [...spjdData.Result].sort((a, b) => {
                    return a.ddzc_spjd_xuhao - b.ddzc_spjd_xuhao;
                })
                const arr = sortedData.map((item) => ({
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>{item.ddzc_spjd_name}</span>       ,
                    content:<span style={{fontSize:"12px"}}>{item.ddzc_spjd_yh_name}</span>,
                }))
                setItems([{
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                    content:<span style={{fontSize:"12px"}}>{props.ddzc_uname} {props.ddzc_ctime}</span>,
                },
                {
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                    content:<span style={{fontSize:"12px"}}>{props.ddzc_uname}{props.ddzc_state_time}</span>,
                },...arr]);
            }else{
                setItems([]);
            }
        }
        
        
    },[data, isSuccess,spjdData, spjdIsSuccess,props])
    return (
        <Steps 
            items={items} 
            current={1} 
            size="small" 
            titlePlacement="vertical"
        />
    )
}

export default CostNodeEdit